"use strict";

var app = angular.module('rmProgram');

app.controller('ProgramOverviewCtrl', require('./program_overview_ctrl'));
app.controller('ProgramFormCtrl', require('./program_form_ctrl'));
